var supportV2 = (function() {
  return {
    init: init
  };

  function init() {
    uiBindings();
  }

  function uiBindings() {
    window.addEventListener('load', function () {
      var supportSidebar = getElements('search-support__sidebar')[0],
        supportSidebarContent = getElements('search-support__sidebar-content')[0],
        supportContent = getElements('search-support__content-main')[0],
        feedbackContainerStepOne = getElements('search-support__feedback-main--first-step')[0],
        feedbackContainerStepTwo = getElements('search-support__feedback-main--second-step')[0],
        feedbackContainerStepFinal = getElements('search-support__feedback-main--final-step')[0],
        feedbackContactUsLabel = getElements('search-support__feedback-contact-us')[0],
        feedbackCtaStepOne = getElements('search-support__feedback-thumbs'),
        feedbackCtaStepTwo = getElements('search-support__feedback-cta'),
        feedbackInput = getElements('search-support__feedback-input')[0],
        searchInput = getElements('search-support__search-input')[0],
        stickySearchInput = getElement('support-nav__nav-search-input')[0],
        searchNavInput = getElements('support-nav__nav-search-input')[0],
        searchPressLabel = getElements('search-support__search-enter-icon')[0],
        searchEnterAndClear = getElements('search-support__search-submit-clear')[0],
        searchNavEnterAndClear = getElements('search-support__search-submit-clear--nav')[0],
        contactUsContainer = getElements('search-support__contactus-container')[0],
        sections = getElements('support-nav-section'),
        radioFeedback = getElements('search-support__feedback-radio'),
        radioCheckedValue = '',
        searchFocusFlag = true,
        signedIn = helpDeskOptions.signedIn,
        getNavLinksOfPage = document.querySelectorAll("#support-nav__nav-links .support-nav__nav-link");
    
      function getURLparam(param) {
        var url_string = window.location.href,
          url = new URL(url_string),
          ref = url.searchParams.get(param);
        return ref;
      }
      function removeMainContentHashFromUrl() {
        var urlHash = window.location.hash;
        if (urlHash) {
          var currentUrl = window.location.href.replace(urlHash, '');
          window.history.pushState({}, '', currentUrl);
        }
      }
      function toPascleCase(str) {
        if (!str) {
          return;
        }
        return str
          .replace(new RegExp(/[-_]+/, 'g'), ' ')
          .replace(new RegExp(/[^\w\s]/, 'g'), '')
          .replace(new RegExp(/\s+(.)(\w*)/, 'g'), function ($1, $2, $3) {
            return $2.toUpperCase() + $3.toLowerCase();
          })
          .replace(new RegExp(/\w/), function (s) {
            return s.toUpperCase();
          });
      }
    
      function replaceFreshdeskUrl(str) {
        return str.replace(
          new RegExp('https://s3.amazonaws.com/cdn.freshdesk.com', 'g'),
          'https://www.browserstack.com/freshdesk-assets'
        );
      }
      // EdsEvent Global function
      function getEDSEvents(data) {
        var currentUrl = window.location.href;
        var referrer = getURLparam('ref') || document.referrer;
        if (!data) data = {};
        // path name:  ['supportPage', relatedResources, breadcrumb, productPage, folderPage];
        return {
          FaqSupportSearchFocus: {
            name: 'InteractedonHelpDesk',
            options: {
              page: helpDeskOptions.page,
              section: 'search',
              signed_in: signedIn
            },
          },
          FaqSupportDynamicSearchClicked: {
            name: 'FaqSupportDynamicSearchClicked',
            options: {
              action: data.action,
              page: helpDeskOptions.page,
              section: 'search',
              clicked_on_URL: data.clicked_on_url,
              position: data.position,
              search_text: data.search_text,
              content_Type: data.content_type
            },
          },
          FAQFeedbackGiven: {
            name: 'FAQFeedbackGiven',
            options: {
              signed_in: signedIn,
              user_signed_in: signedIn,
              title: data.title,
              is_useful: data.isUseful,
              feedbackOption: data.feedbackOption,
              review_text: data.reviewText,
              url: currentUrl,
              time: data.time,
              team: 'web',
            },
          },
        };
      }

      //new eventsTracker
      (function() {
        var linksElems = document.querySelectorAll('.faq-support-v2 a, .faq-support-v2 button, .faq-support a, .faq-support button');
        if (linksElems.length > 0) {
          for (var i = 0; i < linksElems.length; i++) {
            var ele = linksElems[i];
            ele.addEventListener('click', function (e) {
              var that = this;
              if (!(that.closest('.product-section__main') || that.closest('.search-support__feedback-content') || that.closest('#search-support-search-submit') || that.closest('#local-search-autocomplete')) ) {
                var eventName = 'InteractedonHelpDesk',
                  eventObj = {
                    action: 'click',
                    page: helpDeskOptions.page,
                  };
                if (that.closest('.support-nav__nav-search') || that.closest('.search-support__contact-link') ) {
                  eventObj.section = 'Search';
                } else if (that.closest('.search-support__search-tip')) {
                  eventObj.section = 'Popular Searches';
                } else if (that.closest('.search-support__contact-text')) {
                  eventObj.section = 'Contact Support Icon';
                } else if (that.closest('.support-nav__nav-link')) {
                  eventObj.section = 'Secondary Navigation';
                } else if (that.closest('.breadcrumb-elm') || that.closest('.faq-support__breadcrumb')) {
                  eventObj.section = 'Breadcrumb navigation';
                } else if (that.closest('#support-nav__dropdown--toggle')) {
                  if (helpDeskOptions.page == 'FAQ Page') {
                    eventObj.section = 'Left navigation';
                  } else {
                    eventObj.section = 'Secondary navigation';
                  }
                } else if (that.closest('#PopularDocsSection')) {
                  eventObj.section = 'Popular Docs';
                } else if (that.closest('#PopularQuestionsSection')) {
                  eventObj.section = 'Most Popular Question';
                } else if (that.closest('.support-resources__content')) {
                  eventObj.section = 'Other Resources';
                } else if (that.closest('.faq-support-v2__recent-topics-list')) {
                  eventObj.section = 'Left Navigation';
                } else if (that.closest('.faq-support-v2__aticles-item')) {
                  eventObj.section = 'FAQs section';
                } else if (that.closest('.faq-support-v2__article-more')) {
                  eventObj.section = 'View More';
                } else if (that.closest('.faq-support-v2__recent-articles-list-item')) {
                  eventObj.section = 'Related articles';
                } else if (that.closest('#ContactSupportFooter')) {
                  eventObj.section = 'Contact Footer';
                } else if (that.closest('#OtherToolsSection')) {
                  eventObj.section = 'Other Tools';
                } else if (that.closest('#BrowsebyTopicSection')) {
                  eventObj.section = 'Browse by Topic';
                } else if (that.closest('#Browsebydocumentation')) {
                  eventObj.section = 'Browse Documentation';
                } else if (that.closest('#DiscordCommunitySection')) {
                  eventObj.section = 'Discord';
                } else if (that.closest('#whats-new')) {
                  eventObj.section = 'Ad Spaces';
                } else if (that.closest('#SupportDiscord')) {
                  eventObj = {
                    section: 'Discord',
                    action: 'discordCTAClick',
                    page: helpDeskOptions.page,
                  };
                }
                if (that.hasAttribute('data-card-ampjson')) {
                  cardAmpEventProperties = that.getAttribute('data-card-ampjson');
                  if (cardAmpEventProperties) {
                    cardAmpJson = bsLib.JSONParse(cardAmpEventProperties);
                    eventObj = bsLib.extend(eventObj, cardAmpJson);
                  }
                }

                eventObj.clicked_title = that.textContent;

                //update title
                if (that.closest('.card-b-6__block-link')) {
                  eventObj.clicked_title = that.querySelector(".card-b-6__block-title").textContent;
                }

                var featureBox = that.closest('.feature__box-style');
                if (featureBox) {
                  var heading = featureBox.querySelector('.feature__heading');
                  if (heading) {
                    eventObj.clicked_title = heading.textContent;
                  }
                }

                
                if (that.tagName.toLowerCase() === 'a' && that.hasAttribute('href')) {
                  eventObj.destination_url = that.getAttribute('href');
                }

                eventObj.signedin = signedIn;

                if (helpDeskOptions.product && helpDeskOptions.product.trim() !== '') {
                  eventObj.product = helpDeskOptions.product;
                }
                if (helpDeskOptions.faq_page_type && helpDeskOptions.faq_page_type.trim() !== '') {
                  eventObj.faq_page_type = helpDeskOptions.faq_page_type;
                
                  if (that.closest('.faq-support-v2__recent-topics-list-item-accord')) {
                    eventObj.FAQ_left_nav_element = 'Expand';
                  } else if (that.closest('.faq-support-v2__recent-topics-list-item-secondary-wrapper')) {
                    eventObj.FAQ_left_nav_element = 'Sub Topic';
                  } else if (that.closest('.faq-support-v2__recent-topics-list-item-wrapper')) {
                    eventObj.FAQ_left_nav_element = 'Topic';
                  }
                }

                logEdsEvent(eventName, eventObj);
              }
            });
          }
        }
      })();

      // Log EDS events
      function logEdsEvent(eventName, eventData) {
        if (window.WebEventTracker && window.WebEventTracker.logEvent && window.EDS) {
          setTimeout(function () {
            window.WebEventTracker.logEvent(window.EDS.webEvents, eventName, eventData);
          }, 10);
        }
      }

      // get Current Scroll
      function getCurrentScroll() {
        return window.scrollY || document.documentElement.scrollTop;
      }
      function getElement(id) {
        return document.getElementById(id);
      }
      function getElements(className) {
        return document.querySelectorAll('.' + className);
      }
      function from(array, callback) {
        for (var index = 0; index < array.length; index++) {
          callback(array[index], index);
        }
      }
      function formatSizeUnits(bytes) {
        if (bytes >= 1073741824) {
          bytes = Number(bytes / 1073741824).toFixed(2) + ' GB';
        } else if (bytes >= 1048576) {
          bytes = Number(bytes / 1048576).toFixed(2) + ' MB';
        } else if (bytes >= 1024) {
          bytes = Number(bytes / 1024).toFixed(0) + ' KB';
        } else if (bytes > 1) {
          bytes = bytes.toFixed(0) + ' bytes';
        } else if (bytes == 1) {
          bytes = bytes + ' byte';
        } else {
          bytes = '0 bytes';
        }
        return bytes;
      }
      function handleRenderAttachments(attachments) {
        if (attachments && attachments.length) {
          from(attachments, function (item, index) {
            var attachmentItem = getElement('search-support-attachment-' + index);
            if (!attachmentItem) return;
            attachmentItem.classList.remove('search-support__attachment--no-pointer-events');
            attachmentItem.querySelector('.search-support__attachment-name').innerHTML = item.name;
            attachmentItem.querySelector('.search-support__attachment-size').innerHTML = formatSizeUnits(item.size);
            attachmentItem.querySelector('.search-support__attachment-type').innerHTML = item.name.split('.')[1] + ' -';
    
            attachmentItem.href = replaceFreshdeskUrl(item.attachment_url);
          });
        }
      }
      function fetchAttachments(id) {
        var xhttp = new XMLHttpRequest();
        xhttp.onload = function () {
          handleRenderAttachments(JSON.parse(this.response));
        };
        xhttp.open('GET', '/wp-json/get-attachment-details/v1/faq/' + id);
        xhttp.send();
      }
      function addHeightSupportV2() {
        var current = '';
    
        // Use a for loop instead of forEach
        from(sections, function (sec) {
          
          var sectionTop = sec.getBoundingClientRect().top;
          // Adjust the condition as needed based on your specific requirements
          if (sectionTop <= window.innerHeight / 2) {
            current = sec.getAttribute('id');
          }
        });
    
        // Add 'active' class to the corresponding navigation link
        var navActive = false,
          navLinks = document.querySelectorAll('.support-nav__nav-link');
        for (var i = 0; i < navLinks.length; i++) {
          
          var link = navLinks[i],
          supportTggleEle = document.querySelector('.support-nav__dropdown--toggle');
          link.classList.remove('active');

          // Adjust the condition based on the href attribute or other criteria
          if (current && link.getAttribute('href').trim().slice(1).toLowerCase() === current.toLowerCase()) {
            link.classList.add('active');
            if (supportTggleEle) {
              supportTggleEle.innerText = link.innerText;
            }
            
            navActive = true;
          }
        }

        //set default active
        if (!navActive && navLinks.length > 0) {
          var link = navLinks[0],
          supportTggleEle = document.querySelector('.support-nav__dropdown--toggle');
          link.classList.add('active');
          if (supportTggleEle) {
            supportTggleEle.innerText = link.innerText;
          }
        }
      }
      function sidebarScrollHandler() {
        var sideBarFixedClass = 'search-support__sidebar--fixed',
          sideBarBottomFixedClass = 'search-support__sidebar--bottom-fixed';
        if (document.body.clientWidth < 1024) {
          return;
        }
        if (!supportSidebarContent && !supportContent) {
          return;
        }
        var contentIsLess = supportSidebarContent.clientHeight > supportContent.clientHeight;
        var pageScroll = 180,
          scroll = getCurrentScroll();
        if (scroll >= pageScroll && !contentIsLess) {
          supportSidebar.classList.add(sideBarFixedClass);
          supportSidebar.classList.remove(sideBarBottomFixedClass);
        } else {
          supportSidebar.classList.remove(sideBarFixedClass);
        } // for footer
        var scrollTop = getCurrentScroll(),
          isCatPage = window.location.pathname.indexOf('/support/') > -1,
          footerTop = document.querySelector('footer').offsetTop,
          contactUsTop = 0,
          viewPortHeight = document.body.clientHeight;
        if (isCatPage && contactUsContainer) {
          contactUsTop = contactUsContainer.offsetTop;
        }
        if (scrollTop > viewPortHeight / 2 && !contentIsLess) {
          var lastSectionTop = isCatPage ? contactUsTop : footerTop;
          if (lastSectionTop - (viewPortHeight + 10) >= scrollTop) {
            supportSidebar.classList.add(sideBarFixedClass);
            supportSidebar.classList.remove(sideBarBottomFixedClass);
          } else {
            supportSidebar.classList.add(sideBarBottomFixedClass);
          }
        }
        
      }
      function sidebarResizelHandler() {
        var sideBarFixedClass = 'search-support__sidebar--fixed';
        if (document.body.clientWidth > 1024) {
          return;
        }
        if (supportSidebar) {
          supportSidebar.classList.remove(sideBarFixedClass);
        }
      }
      function searchInputFocusHandler(e) {
        if (searchInput !== document.activeElement) {
          if (e) e.preventDefault();
          searchInput.focus();
          searchPressLabel.classList.add('search-support__search-enter-icon--hidden');
          removeMainContentHashFromUrl();
        }
      }

      //Onload
      sidebarScrollHandler();
      addHeightSupportV2();

      window.addEventListener('scroll', function () {
        sidebarScrollHandler();
        addHeightSupportV2();
      });
    
      window.addEventListener('resize', function () {
        sidebarResizelHandler();
        addHeightSupportV2();
      });
    
      // Search handlers
      document.addEventListener('keypress', function (e) {
        if (e.code === 'Slash' || e.key === '/') {
          searchInputFocusHandler(e);
        }
      });
      if (searchPressLabel) {
        searchPressLabel.addEventListener('click', function () {
          searchInputFocusHandler(null);
        });
      }
      if (searchInput) {
        searchInput.addEventListener('blur', function (e) {
          if (!e.target.value) {
            searchPressLabel.classList.remove('search-support__search-enter-icon--hidden');
          }
        });
        searchInput.addEventListener('focus', function (e) {
          searchPressLabel.classList.add('search-support__search-enter-icon--hidden');
          if (searchFocusFlag) {
            var event = getEDSEvents()['FaqSupportSearchFocus'];
            logEdsEvent(event.name, event.options);
          }
          if (!searchFocusFlag) {
            searchFocusFlag = true;
          }
          removeMainContentHashFromUrl();
        });
    
        searchInput.addEventListener('keyup', function (e) {
          var value = e.target.value;
          if (value) {
            searchEnterAndClear.classList.remove('search-support__search-submit-clear--hidden');
            searchInput.classList.remove('search-support__search-input--no-padding');
          } else {
            searchEnterAndClear.classList.add('search-support__search-submit-clear--hidden');
            searchInput.classList.add('search-support__search-input--no-padding');
          }
        });
      }

      if (stickySearchInput) { 
        stickySearchInput.addEventListener('focus', function (e) {
          var event = getEDSEvents()['FaqSupportSearchFocus'];
          logEdsEvent(event.name, event.options);
        });
      }

      //Search Nav Input
      if (searchNavInput) {
        searchNavInput.addEventListener('blur', function (e) {
          if (!e.target.value) {
            searchPressLabel.classList.remove('search-support__search-enter-icon--hidden');
          }
        });
        searchNavInput.addEventListener('focus', function (e) {
          searchPressLabel.classList.add('search-support__search-enter-icon--hidden');
          if (searchFocusFlag) {
            var event = getEDSEvents()['FaqSupportSearchFocus'];
            logEdsEvent(event.name, event.options);
          }
          if (!searchFocusFlag) {
            searchFocusFlag = true;
          }
          removeMainContentHashFromUrl();
        });
    
        searchNavInput.addEventListener('keyup', function (e) {
          var value = e.target.value;
          if (value) {
            searchNavEnterAndClear.classList.remove('search-support__search-submit-clear--hidden');
            searchNavInput.classList.remove('search-support__search-input--no-padding');
          } else {
            searchNavEnterAndClear.classList.add('search-support__search-submit-clear--hidden');
            searchNavInput.classList.add('search-support__search-input--no-padding');
          }
        });
      }
      if (document.body.classList.contains('load-article-attachments')) {
        var freshdeskId = document.body.getAttribute('data-freshdesk-id');
        fetchAttachments(freshdeskId);
      }
      
      // Feedback widget
      function handleStepOneFunction(element) {
        if (feedbackContainerStepTwo && feedbackContainerStepOne) {
          var timeFrame = Date.now();
          var satisfied = element.getAttribute('data-value');
          feedbackContainerStepTwo.classList.remove('search-support__feedback-main--hide');
          feedbackContainerStepTwo.setAttribute('data-value', satisfied);
          feedbackContainerStepTwo.setAttribute('data-time', timeFrame);
          feedbackContainerStepOne.classList.add('search-support__feedback-main--hide');
          var feedbackLabel = getElements('search-support__feedback-label--' + satisfied);
          feedbackInput.focus();
          if (feedbackLabel && feedbackLabel.length) {
            from(feedbackLabel, function (ele) {
              ele.classList.remove('search-support__feedback-label--hide');
            });
            var data = {
              title: getElements('faq-support-v2__category__name')[0].innerText,
              isUseful: satisfied === 'like',
              time: timeFrame,
            };
            var event = getEDSEvents(data)['FAQFeedbackGiven'];
            logEdsEvent(event.name, event.options);
          }
        }
      }
      function handleStepTwoFunction() {
        if (feedbackContainerStepTwo && feedbackContainerStepFinal) {
          feedbackContainerStepFinal.classList.remove('search-support__feedback-main--hide');
          feedbackContainerStepTwo.classList.add('search-support__feedback-main--hide');
          var dataValue = feedbackContainerStepTwo.getAttribute('data-value');
          var timeFrame = feedbackContainerStepTwo.getAttribute('data-time');
          if (feedbackContactUsLabel && dataValue === 'dislike') {
            feedbackContactUsLabel.classList.remove('search-support__feedback-label--hide');
          }
          var data = {
            title: getElements('faq-support-v2__category__name')[0].innerText,
            isUseful: dataValue === 'like',
            reviewText: feedbackInput.value,
            feedbackOption: radioCheckedValue,
            time: timeFrame,
          };
          var event = getEDSEvents(data)['FAQFeedbackGiven'];
          logEdsEvent(event.name, event.options);
        }
      }
    
      // Event listener Step one feedback
      if (feedbackCtaStepOne && feedbackCtaStepOne.length) {
        from(feedbackCtaStepOne, function (element) {
          element.addEventListener('click', function (e) {
            handleStepOneFunction(element);
          });
        });
      }
      if (radioFeedback && radioFeedback.length) {
        from(radioFeedback, function (element) {
          element.addEventListener('change', function (e) { 
            feedbackCtaStepTwo[1].classList.remove('search-support__feedback-cta--disable');
            feedbackCtaStepTwo[1].removeAttribute('disabled');
            radioCheckedValue = element.value;
          });
        });
      }
      // Event listener Step two feedback
      if (feedbackCtaStepTwo && feedbackCtaStepTwo.length) {
        from(feedbackCtaStepTwo, function (element) {
          element.addEventListener('click', function (e) {
            var dataValue = e.target.getAttribute('data-value');
            handleStepTwoFunction(dataValue);
          });
        });
      }
      // EventListener Text area feedback
      if (feedbackInput) {
        feedbackInput.addEventListener('keyup', function (e) {
          if (e.target.value) {
            feedbackCtaStepTwo[1].classList.remove('search-support__feedback-cta--disable');
            feedbackCtaStepTwo[1].removeAttribute('disabled');  
          } else {
            feedbackCtaStepTwo[1].classList.add('search-support__feedback-cta--disable');
            feedbackCtaStepTwo[1].setAttribute('disabled');
          }
        });
      }

      // Dynamic Results Algolia Search Functionality
      (function faqHandleKeyboardNavigation() {
        var faqList = document.getElementById('local-search-autocomplete'),
          faqSearchInput = document.querySelectorAll('.search-support__search-input')[0],
          faqItems = faqList.getElementsByTagName('a'),
          faqSelectedItem = null;
      
        faqSearchInput.addEventListener('keydown', function(event) {
          if (faqItems.length > 0 && event.key === 'ArrowDown') {
            faqItems[0].focus();
            faqSelectedItem = faqItems[0];
          }
          if (event.key === 'Escape' || event.keyCode === 27) {
            faqSearchInput.value = '';
            searchFocusFlag = false;
            faqSearchInput.focus();
            faqList.innerHTML = '';
            searchEnterAndClear.classList.add('search-support__search-submit-clear--hidden');
            faqSearchInput.classList.add('search-support__search-input--no-padding');
          }
        });
      
        faqList.addEventListener('keydown', function(event) {
          if (event.key === 'ArrowDown') {
            // Move focus to the next list item
            faqSelectedItem = faqGetNextItem(faqSelectedItem);
            faqSelectedItem.focus();
            event.preventDefault();
          } else if (event.key === 'ArrowUp') {
            // Move focus to the previous list item
            faqSelectedItem = faqGetPreviousItem(faqSelectedItem);
            faqSelectedItem.focus();
            event.preventDefault();
          } else if (event.key === 'Escape' || event.keyCode === 27) {
            faqSearchInput.value = '';
            searchFocusFlag = false;
            faqSearchInput.focus();
            faqList.innerHTML = '';
            searchEnterAndClear.classList.add('search-support__search-submit-clear--hidden');
            faqSearchInput.classList.add('search-support__search-input--no-padding');
          }
        });
      
        // Helper function to get the next list item
        function faqGetNextItem(item) {
          if (!item) {
            return faqItems[0];
          }
          if (item.nextElementSibling) {
            return item.nextElementSibling;
          }
          return faqItems[0];
        }
      
        // Helper function to get the previous list item
        function faqGetPreviousItem(item) {
          if (!item) {
            return faqItems[0];
          }
          if (item.previousElementSibling) {
            return item.previousElementSibling;
          }
          return faqItems[faqItems.length - 1];
        }
      })();
    
      // recursive function to determine the parent anchor element of the suggestion list
      function findTargetAnchor(target) {
        if (target) {
          if (target.nodeName.toLowerCase() === 'a') {
            return target;
          }
          return findTargetAnchor(target.parentNode);
        }
      }
    
      // handling analytics for dynamic results click
      (function() {
        var autocomplete = document.getElementById('local-search-autocomplete');
        autocomplete.addEventListener('click', function(event) {
          var targetAnchor = findTargetAnchor(event.target);
          if (targetAnchor) {
            var data = {
              action: targetAnchor.classList.contains('global-search__see-all-result')
                ? 'see_all_result'
                : 'clicked_on_drop_down_result',
              clicked_on_url: targetAnchor.getAttribute('href'),
              position: targetAnchor.getAttribute('data-index') + 1,
              search_text: targetAnchor.getAttribute('data-query'),
              content_type: targetAnchor.classList.contains('global-search__see-all-result')
                ? ''
                : targetAnchor.getAttribute('data-category')
            };
            var event = getEDSEvents(data)['FaqSupportDynamicSearchClicked'];
            logEdsEvent(event.name, event.options);
          }
        });
      })();

      // handling analytics for dynamic results click sub nav sticky
      (function() {
        var subNavSearch = document.getElementById('local-nav-search-autocomplete');
        subNavSearch.addEventListener('click', function(event) {
          var targetAnchor = findTargetAnchor(event.target);
          if (targetAnchor) {
            var data = {
              action: targetAnchor.classList.contains('global-search__see-all-result')
                ? 'see_all_result'
                : 'clicked_on_drop_down_result',
              clicked_on_url: targetAnchor.getAttribute('href'),
              position: targetAnchor.getAttribute('data-index') + 1,
              search_text: targetAnchor.getAttribute('data-query'),
              content_type: targetAnchor.classList.contains('global-search__see-all-result')
                ? ''
                : targetAnchor.getAttribute('data-category')
            };
            var event = getEDSEvents(data)['FaqSupportDynamicSearchClicked'];
            logEdsEvent(event.name, event.options);
          }
        });
      })();

      //set BG of template
      (function() {
        if (document.body.classList.contains("page-template-page-support-v2") && getNavLinksOfPage.length > 0) {
          var eleContactSupportFooter = document.getElementById("ContactSupportFooter"),
            adSpacesSupport = document.getElementById("whats-new"),
            eleResources = document.getElementById("Resources");
          
          if (adSpacesSupport) {
            adSpacesSupport.classList.add("reverse-bg");
            if (eleResources) {
              eleResources.classList.add("reverse-bg");
            }
          }
          if (getNavLinksOfPage.length % 2 == 1) {

            if (eleResources && !adSpacesSupport) {
              eleResources.classList.add("reverse-bg");
            }

            if (eleContactSupportFooter) {
              eleContactSupportFooter.classList.add("reverse-bg");
            }
          }
          else {
            
            if (eleContactSupportFooter) {
              eleContactSupportFooter.classList.add("reverse-bg");
            }
          }
        } 
      })();
    });
  }

})();

supportV2.init();